import { DOCS_URL } from "../../../config/constants.js";
import { ETitleFontSizes } from "../../../config/enums.js";
import CardGrid from "./CardGrid.svelte";

export default {
    component: CardGrid,
    name: "Card Grid",
    description: "Standard Card Grid component to contain cards",
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/grid-dots.svg",
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2F4b34067aba514e11bfc0e4741e753247",
    docsLink: `${DOCS_URL}/storybook/?path=/docs/molecules-cardgrid--docs`,
    canHaveChildren: true,
    defaultChildren: [
        {
            "@type": "@builder.io/sdk:Element",
            component: {
                name: "Card Grid - Card",
                options: { title: "I am Card Grid - Card!" },
            },
        },
    ],
    inputs: [
        {
            friendlyName: "Header",
            name: "header",
            type: "longText",
        },
        {
            friendlyName: "Heading Level (Semantic)",
            name: "headingLevel",
            type: "text",
            enum: ["h1", "h2", "h3", "h4", "h5", "h6"],
            defaultValue: "h2",
            helperText: "Select the semantic HTML heading level for SEO and accessibility",
            showIf: `options.get('header') !== ''`,
        },
        {
            friendlyName: "Title Font Size",
            name: "titleSize",
            type: "text",
            enum: Object.values(ETitleFontSizes),
            defaultValue: ETitleFontSizes.H2,
            showIf: `options.get('header') !== ''`,
        },
        {
            friendlyName: "CTA To",
            name: "ctaTo",
            type: "text",
        },
        {
            friendlyName: "CTA Text",
            name: "ctaText",
            type: "text",
        },
        {
            friendlyName: "DON'T use alternating row columns",
            name: "noAlternatingColumns",
            helperText: "If checked, the grid will not switch to 3 columns on each alternate row",
            type: "boolean",
            defaultValue: false,
        },
    ],
    childRequirements: {
        message: "You can only put Card Grid - Card components here",
        query: {
            "component.name": { $in: ["Card Grid - Card"] },
        },
    },
};
